import React, {
  useState, useEffect, useContext, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import Form from '@advisa/onboarding-form';
import LanguageContext from '../../../../../context/language';

const mapPrefilledValuesToApplicant = (prefilledValues) => ({
  civilStatus: prefilledValues.civilStatus || '',
  email: prefilledValues.email || '',
  phoneNumber: prefilledValues.phoneNumber || '',
  dependants: prefilledValues.dependants === 'null' ? 0 : (String(prefilledValues.dependants) || '0'),
  homeType: prefilledValues.homeType || '',
  homeCost: prefilledValues.homeCost || '',
  otherLivingCost: prefilledValues.otherLivingCost || '',
  monthlySalary: prefilledValues.monthlySalary || '',
  annualIncomeBeforeTax: prefilledValues.annualIncomeBeforeTax || '',
  monthlyIncomeBeforeTax: prefilledValues.monthlyIncomeBeforeTax || '',
  monthlyIncomeAfterTax: prefilledValues.monthlyIncomeAfterTax || '',
  employmentType: prefilledValues.employmentType || '',
  employmentSince: prefilledValues.employmentSince || '',
  employmentSinceMonth: prefilledValues.employmentSinceMonth || '',
  employmentTo: prefilledValues.employmentTo || '',
  employmentToMonth: prefilledValues.employmentToMonth || '',
  employerName: prefilledValues.employerName || '',
  employerPhone: prefilledValues.employerPhone || '',
  businessOrganizationNumber: prefilledValues.businessOrganizationNumber || '',
  employmentIndustry: prefilledValues.employmentIndustry || '',
  occupationCategory: prefilledValues.occupationCategory || '',
  occupationTitle: prefilledValues.occupationTitle || '',
  educationLevel: prefilledValues.educationLevel || '',
  moveInDate: prefilledValues.moveInDate || '',
  citizenship: prefilledValues.citizenship || '',
  homeTypeCategory: prefilledValues.homeTypeCategory || '',
  otherIncomeSource: prefilledValues.otherIncomeSource || '',
  otherMonthlyIncomeAfterTax: prefilledValues.otherMonthlyIncomeAfterTax || '',
  otherMonthlyIncomeBeforeTax: prefilledValues.otherMonthlyIncomeBeforeTax || '',
  otherIncome: prefilledValues.otherIncome || false,
  hasRentalIncome: prefilledValues.hasRentalIncome || false,
  spouseMonthlyIncomeBeforeTax: prefilledValues.spouseMonthlyIncomeBeforeTax || '',
  militaryServiceStatus: prefilledValues.militaryServiceStatus || '',
  rentalMonthlyIncomeBeforeTax: prefilledValues.rentalMonthlyIncomeBeforeTax || '',
  spouseAnnualIncomeBeforeTax: prefilledValues.spouseAnnualIncomeBeforeTax || '',
});

const NewFormBlock = ({ prefilledValuesNewForm }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isPrefillPage, setIsPrefillPage] = useState(false);
  const environment = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  const { lang } = useContext(LanguageContext);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.location.pathname === '/preappsms/' || window.location.pathname === '/preappemail/') {
      setIsPrefillPage(true);
    }
  }, []);

  const applicantData = useMemo(() => mapPrefilledValuesToApplicant(prefilledValuesNewForm),
    [prefilledValuesNewForm]);

  const MemoForm = useMemo(() => {
    const initEnv = {
      pre: {
        applicant: applicantData,
      //  secondaryApplicant: {
      //
      //  },
      //  data: {
      //
      //  }
      },
      site: 'SE',
      brand: 'advisa',
      layout: '',
      isPrefillPage,
      lang,
      info: {
        dataPolicy: 'https://advisa.se/om-advisa/dataskyddspolicy/',
        userAgreement: 'https://advisa.se/om-advisa/anvandarvillkor/',
        calculator: {
          amount: 150000, // This and the one below are for "hardcoded" calcs I imagine
          repaymentTime: 5, // In years
          interest: 6.94,
        },
      },
      environment,
    };
    return <Form {...initEnv} />;
  }, [applicantData, environment, isPrefillPage, lang]);

  return (
    <>
      {isMounted && MemoForm}
    </>
  );
};

NewFormBlock.propTypes = {
  prefilledValuesNewForm: PropTypes.shape(),
};

NewFormBlock.defaultProps = {
  prefilledValuesNewForm: {},
};

export default NewFormBlock;
